export function hasResponseOKStatus(response: { status: number }): boolean {
  return response.status === 200 || response.status === 204;
}
export function hasResponseRedirectStatus(response: { status: number }): boolean {
  return response.status === 200 || response.status === 204;
}
